import { Illustration } from '@shared/ui'

/** Иллюстрация окон про город (590:28643 `img-choose-format`, 178×200 — не квадратная,
 *  в отличие от соседних). */
const CITY_DIALOG_ILLUSTRATION = '/images/img-choose-format.png'

/** Слот под визуал `ResultDialog` у трёх окон про город: при входе, перед записью и
 *  «Выберите другой город». */
export const CITY_DIALOG_VISUAL_CLASS = 'h-50 w-44.5'

/** Один визуал на три окна про город. */
export function CityDialogVisual() {
  return (
    <Illustration
      src={CITY_DIALOG_ILLUSTRATION}
      alt=""
      className={`${CITY_DIALOG_VISUAL_CLASS} object-contain`}
    />
  )
}
